import React from "react"
import { Form } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

import { getPriceView, getSelectedProduct } from "@/onboarding/features/cost_analysis/selectors"
import { selectView, ViewTypes } from "@/onboarding/features/cost_analysis/Slice"

const PriceViewDropdown = (): JSX.Element => {
  const dispatch = useDispatch()
  const selectedView = useSelector(getPriceView)
  const selectedProduct = useSelector(getSelectedProduct)

  if (!selectedProduct) {
    return null
  }

  return (
    <Form.Group>
      <Form.Label>Cost View</Form.Label>
      <Form.Control
        as="select"
        value={selectedView}
        onChange={({ target }) => dispatch(selectView({ selectedView: target.value }))}
      >
        {selectedProduct.showVariances && (
          <option value={ViewTypes.BREAKDOWN_VARIANCE}>Pax Type Variances</option>
        )}
        <option value={ViewTypes.BREAKDOWN}>Pax Types</option>
        {selectedProduct.showVariances && (
          <option value={ViewTypes.AGGREGATE_VARIANCE}>Total Cost Variances</option>
        )}
        <option value={ViewTypes.AGGREGATE}>Total Costs</option>
      </Form.Control>
    </Form.Group>
  )
}

export default PriceViewDropdown
